import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "d-flex align-center px-2 py-1" }
const _hoisted_2 = { class: "d-flex align-center flex-grow-1" }
const _hoisted_3 = {
  key: 0,
  class: "mx-0 my-2 pa-0"
}
const _hoisted_4 = { class: "d-flex align-center" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "secrets-section" }
const _hoisted_7 = { class: "secrets-header d-flex align-center justify-space-between mb-3" }
const _hoisted_8 = {
  key: 1,
  class: "text-center text-body-2 text-medium-emphasis py-4"
}
const _hoisted_9 = { class: "d-flex align-center" }
const _hoisted_10 = {
  key: 0,
  class: "logs-container"
}
const _hoisted_11 = { class: "logs-text" }
const _hoisted_12 = {
  key: 1,
  class: "text-body-2"
}
const _hoisted_13 = {
  key: 1,
  class: "card-action-overlay"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_Button = _resolveComponent("Button")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "mb-4 pa-2 card bg-background",
    color: "background",
    variant: "elevated",
    elevation: "4",
    density: "compact"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_tooltip, {
          text: _ctx.isConnected ? 'Connected' : 'Disconnected',
          location: "top"
        }, {
          activator: _withCtx(({ props }) => [
            _createVNode(_component_v_icon, _mergeProps(props, {
              color: _ctx.isConnected ? 'success' : 'error',
              class: "mr-2"
            }), {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.isConnected ? 'mdi-checkbox-marked-circle-outline' : 'mdi-alert-circle-outline'), 1)
              ]),
              _: 2
            }, 1040, ["color"])
          ]),
          _: 1
        }, 8, ["text"]),
        _createElementVNode("div", _hoisted_2, [
          (!_ctx.editingName)
            ? (_openBlock(), _createBlock(_component_v_card_title, {
                key: 0,
                class: "max-85 pr-0 py-1"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.name), 1)
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock("span", {
                key: 1,
                class: "title-edit-wrapper max-85 pr-0",
                contenteditable: "true",
                ref: "titleEdit",
                onBlur: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.saveNameFromEdit && _ctx.saveNameFromEdit(...args))),
                onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.saveNameFromEdit && _ctx.saveNameFromEdit(...args)), ["prevent"]), ["enter"]))
              }, null, 544)),
          (!_ctx.editingName && _ctx.show && _ctx.isAdmin)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 2,
                color: "primary",
                class: "ml-2",
                click: _ctx.toggleEditName,
                icon: "mdi-pencil",
                size: "small",
                tooltip: "Edit Server Name",
                density: "compact"
              }, null, 8, ["click"]))
            : _createCommentVNode("", true),
          (_ctx.editingName && _ctx.show && _ctx.isAdmin)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 3,
                color: "primary",
                class: "ml-2",
                click: _ctx.saveNameFromEdit,
                icon: "mdi-check",
                size: "small",
                tooltip: "Save Name",
                density: "compact"
              }, null, 8, ["click"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_v_btn, {
          color: "primary",
          class: "ml-auto",
          icon: _ctx.show ? 'mdi-chevron-up' : 'mdi-chevron-down',
          onClick: _ctx.toggleExpand,
          density: "compact"
        }, null, 8, ["icon", "onClick"])
      ]),
      (_ctx.show)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_v_divider)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_v_form, {
        class: "ma-0 pa-0 bg-background",
        onSubmit: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["prevent"])),
        density: "compact"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_expand_transition, null, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_v_list, {
                class: "ma-0 px-0 pt-0 pb-2 bg-background card-content",
                density: "compact"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, {
                    class: _normalizeClass(_ctx.showGlobalTooltips ? 'mt-2 mb-n4 ml-6 mr-0 pa-0' : 'ma-0 pa-0'),
                    density: "compact"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.showGlobalTooltips)
                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                            key: 0,
                            location: "top",
                            "max-width": "300",
                            text: "The command used to run this MCP server."
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_v_icon, _mergeProps(props, {
                                size: "x-small",
                                color: "warning",
                                class: "global-tooltip-icon mt-5 ml-n6"
                              }), {
                                default: _withCtx(() => _cache[11] || (_cache[11] = [
                                  _createTextVNode("mdi-information-outline")
                                ])),
                                _: 2,
                                __: [11]
                              }, 1040)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.commandString,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.commandString) = $event)),
                        onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.trackFieldUpdate('command_string'))),
                        label: "Run Command",
                        class: "pt-2 text-overflow-ellipsis",
                        variant: "outlined",
                        density: "compact",
                        clearable: "",
                        rules: [() => !!_ctx.commandString || 'Run Command is required']
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  (_ctx.npmPackage)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 0,
                        class: _normalizeClass(_ctx.showGlobalTooltips ? 'mb-0 mt-0 ml-6 mr-0 pa-0' : 'ma-0 pa-0'),
                        density: "compact"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.showGlobalTooltips)
                            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                key: 0,
                                location: "top",
                                "max-width": "300",
                                text: "NPM package detected in the command."
                              }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_icon, _mergeProps(props, {
                                    size: "x-small",
                                    color: "warning",
                                    class: "global-tooltip-icon mt-2 ml-n6"
                                  }), {
                                    default: _withCtx(() => _cache[12] || (_cache[12] = [
                                      _createTextVNode("mdi-information-outline")
                                    ])),
                                    _: 2,
                                    __: [12]
                                  }, 1040)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_4, [
                            _createVNode(_component_v_icon, {
                              class: "mr-2",
                              size: "x-large"
                            }, {
                              default: _withCtx(() => _cache[13] || (_cache[13] = [
                                _createTextVNode("mdi-npm")
                              ])),
                              _: 1,
                              __: [13]
                            }),
                            _createElementVNode("a", {
                              href: _ctx.npmPackageUrl,
                              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.viewNpmPackage && _ctx.viewNpmPackage(...args))),
                              target: "_blank",
                              class: "text-decoration-none npm-link",
                              title: "Go to NPM Package"
                            }, _toDisplayString(_ctx.npmPackage), 9, _hoisted_5)
                          ])
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_list_item, {
                    class: _normalizeClass(_ctx.showGlobalTooltips ? 'mt-0 mb-n4 ml-6 mr-0 pa-0' : 'ma-0 pa-0'),
                    density: "compact"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.showGlobalTooltips)
                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                            key: 0,
                            location: "top",
                            "max-width": "300",
                            text: "A brief description of the MCP server."
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_v_icon, _mergeProps(props, {
                                size: "x-small",
                                color: "warning",
                                class: "global-tooltip-icon mt-5 ml-n6"
                              }), {
                                default: _withCtx(() => _cache[14] || (_cache[14] = [
                                  _createTextVNode("mdi-information-outline")
                                ])),
                                _: 2,
                                __: [14]
                              }, 1040)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.description,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.description) = $event)),
                        loading: _ctx.mcpLoading,
                        disabled: _ctx.mcpLoading,
                        class: "pt-2",
                        onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.trackFieldUpdate('description'))),
                        label: "Server Description",
                        variant: "outlined",
                        density: "compact"
                      }, null, 8, ["modelValue", "loading", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_component_v_list_item, {
                    class: _normalizeClass(_ctx.showGlobalTooltips ? 'mt-0 mb-n2 ml-6 mr-0 pa-0' : 'ma-0 pa-0'),
                    density: "compact"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.showGlobalTooltips)
                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                            key: 0,
                            location: "top",
                            "max-width": "300",
                            text: "Configure up to 5 secrets for this MCP server (e.g., API keys, tokens, passwords)."
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_v_icon, _mergeProps(props, {
                                size: "x-small",
                                color: "warning",
                                class: "global-tooltip-icon mt-3 ml-n6"
                              }), {
                                default: _withCtx(() => _cache[15] || (_cache[15] = [
                                  _createTextVNode("mdi-information-outline")
                                ])),
                                _: 2,
                                __: [15]
                              }, 1040)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-subtitle-2" }, "Server Secrets", -1)),
                          (_ctx.serverSecrets.length < 5)
                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                key: 0,
                                color: "primary",
                                variant: "text",
                                size: "small",
                                "prepend-icon": "mdi-plus",
                                onClick: _ctx.addSecret,
                                density: "compact"
                              }, {
                                default: _withCtx(() => _cache[16] || (_cache[16] = [
                                  _createTextVNode(" Add Secret ")
                                ])),
                                _: 1,
                                __: [16]
                              }, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.serverSecrets, (secret, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "secret-row d-flex align-center gap-2 mb-1"
                          }, [
                            _createVNode(_component_v_text_field, {
                              modelValue: secret.name,
                              "onUpdate:modelValue": ($event: any) => ((secret.name) = $event),
                              label: "Secret Name (e.g., api_key)",
                              placeholder: "api_key",
                              variant: "outlined",
                              density: "compact",
                              class: "secret-name-field",
                              rules: [
                    () => !!secret.name || 'Name is required',
                    () => (secret.name && secret.name.length <= 50) || 'Name must be 50 characters or less'
                  ]
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: secret.value,
                              "onUpdate:modelValue": ($event: any) => ((secret.value) = $event),
                              type: 'password',
                              label: "Secret Value",
                              placeholder: "Enter secret value",
                              variant: "outlined",
                              density: "compact",
                              class: "secret-value-field"
                            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                            _createVNode(_component_v_btn, {
                              icon: "mdi-delete",
                              size: "small",
                              variant: "text",
                              color: "error",
                              onClick: ($event: any) => (_ctx.removeSecret(index)),
                              title: "Remove this secret"
                            }, null, 8, ["onClick"])
                          ]))
                        }), 128)),
                        (_ctx.serverSecrets.length > 0)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 0,
                              color: "primary",
                              variant: "outlined",
                              size: "small",
                              block: "",
                              onClick: _ctx.saveAllSecrets,
                              loading: _ctx.savingSecrets,
                              disabled: _ctx.serverSecrets.every(s => !s.value.trim()) || _ctx.serverSecrets.some(s => s.value.trim() !== '' && !s.name.trim()),
                              class: "mt-2 mb-3"
                            }, {
                              default: _withCtx(() => _cache[18] || (_cache[18] = [
                                _createTextVNode(" Save All Secrets ")
                              ])),
                              _: 1,
                              __: [18]
                            }, 8, ["onClick", "loading", "disabled"]))
                          : _createCommentVNode("", true),
                        (_ctx.serverSecrets.length === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, " No secrets configured. Click \"Add Secret\" to add one. "))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  (_ctx.isAdmin)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 1,
                        class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0' : 'ma-0 pa-0'),
                        density: "compact"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.showGlobalTooltips)
                            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                key: 0,
                                location: "top",
                                "max-width": "300",
                                text: "Enable or disable this MCP server."
                              }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_icon, _mergeProps(props, {
                                    size: "x-small",
                                    color: "warning",
                                    class: "global-tooltip-icon mt-3 ml-n6"
                                  }), {
                                    default: _withCtx(() => _cache[19] || (_cache[19] = [
                                      _createTextVNode("mdi-information-outline")
                                    ])),
                                    _: 2,
                                    __: [19]
                                  }, 1040)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_9, [
                            _cache[20] || (_cache[20] = _createElementVNode("span", { class: "mr-2" }, "Enabled", -1)),
                            _createVNode(_component_v_switch, {
                              modelValue: _ctx.enabled,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.enabled) = $event)),
                              color: "primary",
                              "hide-details": "",
                              density: "compact",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.toggleServerEnabled(!_ctx.enabled)))
                            }, null, 8, ["modelValue"])
                          ])
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true),
                  (_ctx.isAdmin)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 2,
                        class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0' : 'ma-0 pa-0'),
                        density: "compact"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.showGlobalTooltips)
                            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                key: 0,
                                location: "top",
                                "max-width": "300",
                                text: "Server logs."
                              }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_icon, _mergeProps(props, {
                                    size: "x-small",
                                    color: "warning",
                                    class: "global-tooltip-icon mt-5 ml-n6"
                                  }), {
                                    default: _withCtx(() => _cache[21] || (_cache[21] = [
                                      _createTextVNode("mdi-information-outline")
                                    ])),
                                    _: 2,
                                    __: [21]
                                  }, 1040)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_expansion_panels, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_expansion_panel, {
                                title: "Server Logs",
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.trackButtonClick('view_mcp_server_logs', 'click', { server_id: _ctx.serverId }))),
                                density: "compact",
                                class: "bg-background"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_expansion_panel_text, { class: "pa-0 ma-0 logs-panel" }, {
                                    default: _withCtx(() => [
                                      (_ctx.logs && _ctx.logs.length > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                            _createElementVNode("pre", _hoisted_11, _toDisplayString(_ctx.logs.join('')), 1)
                                          ]))
                                        : (_openBlock(), _createElementBlock("p", _hoisted_12, "No logs available"))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 512), [
                [_vShow, _ctx.show]
              ])
            ]),
            _: 1
          }),
          (_ctx.show && _ctx.isAdmin)
            ? (_openBlock(), _createBlock(_component_v_card_actions, {
                key: 0,
                density: "compact"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Button, {
                    color: "primary",
                    class: "mr-4",
                    disabled: _ctx.saveDisabled,
                    click: _ctx.updateServer,
                    icon: "mdi-check-bold",
                    size: "x-large",
                    tooltip: "Save Server",
                    density: "compact"
                  }, null, 8, ["disabled", "click"]),
                  _createVNode(_component_Button, {
                    color: "primary",
                    class: "mr-4",
                    disabled: _ctx.deleteDisabled,
                    click: _ctx.deleteServer,
                    icon: "mdi-trash-can-outline",
                    size: "x-large",
                    tooltip: "Delete Server",
                    density: "compact"
                  }, null, 8, ["disabled", "click"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_ctx.mcpLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.actionMessage), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.mcpError)
        ? (_openBlock(), _createBlock(_component_v_alert, {
            key: 2,
            type: "error",
            class: "ma-2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.mcpError), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}